import { SortingUtil } from '@adsk/docs-js-sdk';

const getUpdatedEntity = (doc, isFolder) => {
  const pathSegments = isFolder
    ? (doc?.parents || []).map(({ title }) => title)
    : [
        ...(doc.parentFolder?.parents || []).map(({ title }) => title),
        doc.parentFolder?.title,
      ];
  const displayPath = pathSegments.filter((title) => !!title).join('/');
  const fullPath = `${displayPath}${displayPath ? '/' : ''}${doc.title}`;
  const keywords =
    (doc.highlights || []).filter(({ field }) =>
      ['content.name', 'name'].includes(field),
    )[0]?.keywords || [];
  return { ...doc, displayPath, fullPath, highlight: keywords };
};

export const processTreeViewEntities = (entities, dataFilter) => {
  // Split entities into folders and documents
  const { folders, documents } = entities.reduce(
    (acc, entity) => {
      const isFolder = 'folderType' in entity;
      const updatedEntity = getUpdatedEntity(entity, isFolder);
      if (isFolder) {
        acc.folders.push(updatedEntity);
      } else {
        acc.documents.push(updatedEntity);
      }
      return acc;
    },
    { folders: [], documents: [] },
  );
  // Order folders and documents individually as search may return in batches with different order
  const sortedFolders = [...folders].sort((a, b) =>
    SortingUtil.naturalCompare(a, b, 'title'),
  );
  const sortedDocuments = [...documents].sort((a, b) =>
    // use `title` as formatEntityItem parsed original `name` as React component for display
    SortingUtil.naturalCompare(a, b, 'title'),
  );
  const sortedEntities = [...sortedFolders, ...sortedDocuments];
  return dataFilter ? dataFilter(sortedEntities) : sortedEntities;
};
